import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation, computed, inject } from '@angular/core';
import { IAddressFormat } from '@partners/api';
import { isEmpty } from '@partners/utils';
import { AddressFacade } from '../../facades/address';

@Component({
  selector: 'address-label',
  standalone: true,
  template: `
    <ng-content></ng-content>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'address'
})
export class AddressLabelComponent {
  @HostBinding('class.address-label')
  hasResidence$$ = computed(() => !isEmpty(this.addressFormat$$()?.residenceName));
  hasStreet$$ = computed(() => !isEmpty(this.addressFormat$$()?.streetName));
  hasZipCode$$ = computed(() => !isEmpty(this.addressFormat$$()?.zipCode));

  protected addressFormat$$ = computed<IAddressFormat>(() => {
    return this._addressFacade.addressFormat$$();
  });

  private _addressFacade = inject(AddressFacade);
}
